import { memo, useCallback } from "react"
import { ObjectStatus } from "@/db/schema"
import { ProjectStatusDialog } from "./ProjectStatusDialog"
import { closeProjectWith, useProjectStatusRequests } from "./projectStatusRequest"

/** Shows the oldest pending complete/cancel request (see `setProjectStatus`). Mount once. */
export const ProjectStatusDialogHost = memo(function ProjectStatusDialogHost() {
  const request = useProjectStatusRequests((s) => s.queue[0])
  const shift = useProjectStatusRequests((s) => s.shift)

  const handleConfirm = useCallback(
    async (childStatus: ObjectStatus) => {
      if (!request) return
      shift()
      await closeProjectWith(request.project.id as string, request.status, childStatus)
    },
    [request, shift],
  )

  if (!request) return null
  return (
    <ProjectStatusDialog
      key={request.project.id}
      open
      onOpenChange={(open) => {
        if (!open) shift()
      }}
      project={request.project}
      unfinished={request.unfinished}
      action={request.status === ObjectStatus.Canceled ? "cancel" : "complete"}
      onConfirm={handleConfirm}
    />
  )
})
